import React from "react";

export function Divider() {
  return (
    <div className="divider" style={{ marginTop: 32, marginBottom: 32 }}></div>
  );
}
